"use strict";

exports.__esModule = true;
exports.CommentWordCountElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _Device = require("../../Device");
var _CommentWordCountTable = require("./CommentWordCountTable");
var _CommentWordCountBarChart = require("./CommentWordCountBarChart");
var _common = require("../common");
var _Time = require("../../Time");
var _getKeywordTermsCount = require("../../../Utils/getKeywordTermsCount");
var _Comment = require("../../Comment");
var _Core = require("../../Core");
var _dec, _dec2, _dec3, _class, _CommentWordCountElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var CommentWordCountElement = exports.CommentWordCountElement = (_dec = _Device.DeviceContext.withContext, _dec2 = _Device.DeviceListContext.withContext, _dec3 = _Time.ReportingPeriodContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = (_CommentWordCountElement = /*#__PURE__*/function (_Component) {
  function CommentWordCountElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderCommentWordCount = function (_ref) {
      var fetching = _ref.fetching,
        error = _ref.error,
        data = _ref.data;
      var _this$props = _this.props,
        width = _this$props.width,
        height = _this$props.height,
        left = _this$props.x,
        top = _this$props.y,
        visualisation = _this$props.visualisation,
        _this$props$minMatche = _this$props.minMatches,
        minMatches = _this$props$minMatche === void 0 ? 0 : _this$props$minMatche,
        _this$props$limitResu = _this$props.limitResults,
        limitResults = _this$props$limitResu === void 0 ? 0 : _this$props$limitResu;
      var style = {
        top: top,
        left: left,
        width: width,
        height: height
      };
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          style: style,
          error: error
        });
      }
      if (fetching) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
      }
      if (data == null || data.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(_core.NonIdealState, {
          style: style,
          title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "CommentWordCountElement.noData",
            defaultMessage: "No comments in this time period"
          })
        });
      }
      var keywordsWithCount = (0, _getKeywordTermsCount.getKeywordTermsCount)(data.map(function (comment) {
        return comment.body;
      }));

      // limit the results by the minimum matches value
      if (minMatches > 0) {
        keywordsWithCount = keywordsWithCount.filter(function (item) {
          return item[1] >= minMatches;
        });
      }

      // limit how many results are shown to the top N
      if (limitResults > 0) {
        keywordsWithCount = keywordsWithCount.slice(0, limitResults);
      }
      switch (visualisation) {
        case "bar":
          return /*#__PURE__*/_react["default"].createElement(_CommentWordCountBarChart.CommentWordCountBarChart, _extends({}, (0, _common.getWidgetInteractionProps)(_this.props), (0, _common.getWidgetPositionProps)(_this.props), {
            data: keywordsWithCount
          }));
        default:
          return /*#__PURE__*/_react["default"].createElement(_CommentWordCountTable.CommentWordCountTable, _extends({}, (0, _common.getWidgetInteractionProps)(_this.props), (0, _common.getWidgetPositionProps)(_this.props), {
            data: keywordsWithCount
          }));
      }
    };
    return _this;
  }
  _inheritsLoose(CommentWordCountElement, _Component);
  var _proto = CommentWordCountElement.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      device = _this$props2.device,
      devices = _this$props2.devices,
      reportingPeriod = _this$props2.reportingPeriod;
    return /*#__PURE__*/_react["default"].createElement(_Comment.CommentLoader, {
      devices: device ? [device] : devices,
      interval: reportingPeriod && reportingPeriod.interval
    }, this.renderCommentWordCount);
  };
  return CommentWordCountElement;
}(_react.Component), _CommentWordCountElement.defaultProps = {
  device: undefined,
  devices: undefined,
  reportingPeriod: undefined
}, _CommentWordCountElement)) || _class) || _class) || _class);